import { ListStatus } from './components/list-status';

export const statusTransform = ({
  isLoading,
  isError,
  hasMore,
  listLength,
}: {
  isLoading: boolean;
  isError: boolean;
  hasMore: boolean;
  listLength: number;
}) => {
  if (isLoading) return ListStatus.LOADING;
  if (isError) return ListStatus.ERROR;
  if (!hasMore && listLength > 0) return ListStatus.NO_MORE;
  if (!hasMore && listLength === 0) return ListStatus.EMPTY;
  return ListStatus.NONE;
};
